import React from "react";
import { RemoveRedEye, LinkAnimation, SwitchStatus, ListUserAttendance } from "../../";
import { makeStyles, Typography, Grid, Collapse, Chip, Button } from "@material-ui/core";
import moment from "moment";
import DoneAllIcon from "@material-ui/icons/DoneAll";
import DoneIcon from "@material-ui/icons/Done";
import AddLocationIcon from "@material-ui/icons/AddLocation";
import LocationOffIcon from "@material-ui/icons/LocationOff";
import PeopleIcon from "@material-ui/icons/People";
import PhoneIcon from "@material-ui/icons/Phone";
import AccessTimeIcon from "@material-ui/icons/AccessTime";
import LocationOnIcon from "@material-ui/icons/LocationOn";
import EmailIcon from "@material-ui/icons/Email";
import KeyboardArrowRightIcon from "@material-ui/icons/KeyboardArrowRight";
import Badge from "@material-ui/core/Badge";
import ChatIcon from "@material-ui/icons/Chat";
import CreateIcon from "@material-ui/icons/Create";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import { useLocation } from "react-router-dom";
import selects from "../../assets/selects";
var useStyles = makeStyles(function (theme) {
  return {
    contained: {
      background: theme.palette.background.paper,
      border: "1px solid " + theme.palette.background.paper,
      borderRadius: "8px"
    },
    outlined: {
      background: theme.palette.background["default"],
      border: "1px solid " + theme.palette.background.paper,
      borderRadius: "8px"
    },
    // PADDINGS AND MARGINS
    pr8: {
      paddingRight: "8px"
    },
    pl8: {
      paddingLeft: "8px"
    },
    p8: {
      padding: "8px"
    },
    pr16: {
      paddingRight: "16px"
    },
    mr8: {
      marginRight: "8px"
    },
    ml8: {
      marginLeft: "8px"
    },
    ml16: {
      marginLeft: "16px"
    },
    my8: {
      margin: "8px 0"
    },
    mt8: {
      marginTop: "8px"
    },
    mt4: {
      marginTop: "4px"
    },
    mb8: {
      marginBottom: "8px"
    },
    mt12b8: {
      margin: "12px 0 8px"
    },
    // END PADDINGS AND MARGINS
    containerIcons: {
      display: "flex",
      flexDirection: "row",
      flex: "0 0 auto"
    },
    containerFlexWrap: {
      display: "flex",
      flexFlow: "row wrap"
    },
    link: {
      color: "inherit"
    },
    iconHorizontal: {
      margin: "0 4px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    },
    iconHorizontalWithoutMargin: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    },
    iconVertical: {
      margin: "0 4px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexDirection: "column"
    },
    linkTelephone: {
      display: "flex",
      alignItems: "center",
      textDecoration: "none",
      color: "inherit"
    },
    w100: {
      width: "100%"
    },
    colorYellow: {
      color: "#ffe082"
    },
    borderYellow: {
      border: "1px solid #ffe082"
    },
    minHeight200: {
      minHeight: "200px",
      display: "flex"
    },
    textFlexWidth: {
      flexGrow: "1",
      whiteSpace: "nowrap",
      overflow: "hidden" // width: "100px",

    },
    textFlexWidthDFlexColumn: {
      flexGrow: "1",
      whiteSpace: "nowrap",
      overflow: "hidden",
      display: "flex",
      flexDirection: "column"
    },
    flexGrow: {
      flexGrow: "1"
    },
    textAnimation3s: {
      display: "inline-block",
      animation: "$animate 3s linear 0s alternate infinite"
    },
    textAnimation5s: {
      display: "inline-block",
      animation: "$animate 5s linear 0s alternate infinite"
    },
    textAnimation7s: {
      display: "inline-block",
      animation: "$animate 7s linear 2s alternate infinite"
    },
    alignItemsCenter: {
      alignItems: "center"
    },
    containerFlexNoWrap: {
      display: "flex",
      flexWrap: "nowrap",
      justifyContent: "space-between",
      flexDirection: "row"
    },
    containerFlex1ColumnAlignCenter: {
      flex: "1",
      display: "flex",
      flexDirection: "column",
      alignItems: "center"
    },
    containerAlert: {
      margin: "4px",
      padding: "4px 8px",
      borderRadius: "8px",
      background: theme.palette.secondary.main
    },
    //TEMPLATES DIV CONTAINER CLASSNAME
    containedFlexColumn: {
      // alignItems: "center",
      padding: "8px",
      background: theme.palette.background.paper,
      border: "1px solid " + theme.palette.background.paper,
      borderRadius: "8px",
      display: "flex",
      flexDirection: "column"
    },
    outlinedPrimaryFlexColumn: {
      // alignItems: "center",
      padding: "8px",
      border: "1px solid " + theme.palette.primary.main,
      borderRadius: "8px",
      display: "flex",
      flexDirection: "column"
    },
    outlinedSecondaryFlexColumn: {
      // alignItems: "center",
      padding: "8px",
      border: "1px solid " + theme.palette.secondary.main,
      borderRadius: "8px",
      display: "flex",
      flexDirection: "column"
    },
    containedflexRowNoWrapMH50: {
      alignItems: "center",
      padding: "8px",
      background: theme.palette.background.paper,
      border: "1px solid " + theme.palette.background.paper,
      borderRadius: "8px",
      display: "flex",
      flexWrap: "no-wrap",
      minHeight: "50px"
    },
    outlinedflexRowNoWrapMH50: {
      alignItems: "center",
      padding: "8px",
      background: theme.palette.background["default"],
      border: "1px solid " + theme.palette.background.paper,
      borderRadius: "8px",
      display: "flex",
      flexWrap: "no-wrap",
      minHeight: "50px"
    },
    "@keyframes animate": {
      "0%": {
        transform: "translateX(0%)"
      },
      "25%": {
        transform: "translateX(0%)"
      },
      "75%": {
        transform: "translateX(-80%)"
      },
      "100%": {
        transform: "translateX(-80%)"
      }
    },
    outlinedFlexColumn: {
      // justifyContent: "center",
      padding: "8px",
      // border: "1px solid " + theme.palette.background.paper,
      borderRadius: "8px",
      display: "flex",
      flexDirection: "column",
      "margin-bottom": "11px"
    },
    fullCardLink: {
      width: "100%",
      display: "flex",
      "align-items": "center",
      "justify-content": "space-between"
    },
    nameContainer: {
      display: "flex",
      flex: "1"
    },
    name: {
      "&:hover": {
        color: theme.palette.primary.main
      },
      marginLeft: "15px"
    },
    chatIcon: {
      color: theme.palette.text.primary
    },
    dflex: {
      display: "flex"
    },
    checkInContainer: {
      // padding: "10px",
      // background: "none",
      display: "flex",
      "flex-direction": "column",
      "justify-content": "center"
    },
    boldText: {
      "font-weight": 600
    },
    chipGroup: {
      borderRadius: "6px",
      background: theme.palette.background.paper,
      margin: "4px",
      border: "1px solid ".concat(theme.palette.text.primary)
    },
    not_attended: {
      border: "1px solid ".concat(theme.palette.secondary.main),
      color: theme.palette.secondary.main
    }
  };
});

var templates = function templates(template, classes, data, location, translation) {
  var content;

  switch (template) {
    case "calendarGroupStaff":
      // ESTADO INICIAL
      if (data.status === "draft") {
        // Comprobar si fecha es hoy
        content = {
          className: moment().isSame(data.date, "day") ? classes.outlinedflexRowNoWrapMH50 : classes.containedflexRowNoWrapMH50,
          content: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
            className: classes.textFlexWidth
          }, /*#__PURE__*/React.createElement(Typography, {
            variant: "body1",
            className: data.group.name ? data.group.name.length > 14 ? classes.textAnimation5s : null : null
          }, data.group.name)), /*#__PURE__*/React.createElement("div", {
            className: classes.containerIcons
          }, /*#__PURE__*/React.createElement("div", {
            className: classes.iconHorizontal
          }, /*#__PURE__*/React.createElement(DoneIcon, {
            color: "primary"
          }), /*#__PURE__*/React.createElement(Typography, {
            variant: "caption",
            className: classes.ml8
          }, data.yes || 0)), /*#__PURE__*/React.createElement("div", {
            className: classes.iconHorizontal
          }, /*#__PURE__*/React.createElement(DoneIcon, {
            className: classes.colorYellow
          }), /*#__PURE__*/React.createElement(Typography, {
            variant: "caption",
            className: classes.ml8
          }, data.maybe || 0)), /*#__PURE__*/React.createElement("div", {
            className: classes.iconHorizontal
          }, /*#__PURE__*/React.createElement(DoneIcon, {
            color: "secondary"
          }), /*#__PURE__*/React.createElement(Typography, {
            variant: "caption",
            className: classes.ml8
          }, data.no || 0))), moment().isSame(data.date, "day") ? /*#__PURE__*/React.createElement("div", {
            className: classes.containerIcons
          }, /*#__PURE__*/React.createElement("div", {
            className: classes.iconVertical,
            onClick: function onClick() {
              return data.handleCheckInClick(data._id, data.group.name);
            }
          }, /*#__PURE__*/React.createElement(AddLocationIcon, {
            color: "primary"
          }), /*#__PURE__*/React.createElement(Typography, {
            variant: "caption"
          }, "Check in"))) : null)
        };
      } // ESTADO CHECK_IN SIN FINALIZAR
      else if (data.status === "checking_in" && data.checkin_pending > 0) {
          content = {
            className: moment().isSame(data.date, "day") ? classes.outlinedflexRowNoWrapMH50 : classes.containedflexRowNoWrapMH50,
            content: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
              className: classes.textFlexWidth
            }, /*#__PURE__*/React.createElement(Typography, {
              variant: "body1",
              className: classes.textAnimation5s
            }, data.group.name)), /*#__PURE__*/React.createElement("div", {
              className: classes.containerIcons
            }, /*#__PURE__*/React.createElement("div", {
              className: classes.iconHorizontal
            }, /*#__PURE__*/React.createElement(DoneIcon, {
              color: "primary"
            }), /*#__PURE__*/React.createElement(Typography, {
              variant: "caption",
              className: classes.ml8
            }, data.yes || 0)), /*#__PURE__*/React.createElement("div", {
              className: classes.iconHorizontal
            }, /*#__PURE__*/React.createElement(DoneIcon, {
              className: classes.colorYellow
            }), /*#__PURE__*/React.createElement(Typography, {
              variant: "caption",
              className: classes.ml8
            }, data.maybe || 0)), /*#__PURE__*/React.createElement("div", {
              className: classes.iconHorizontal
            }, /*#__PURE__*/React.createElement(DoneIcon, {
              color: "secondary"
            }), /*#__PURE__*/React.createElement(Typography, {
              variant: "caption",
              className: classes.ml8
            }, data.no || 0))), moment().isSame(data.date, "day") ? /*#__PURE__*/React.createElement("div", {
              className: classes.containerIcons
            }, /*#__PURE__*/React.createElement("div", {
              className: classes.iconVertical,
              onClick: function onClick() {
                return data.handleCheckInClick(data._id, data.group.name);
              }
            }, /*#__PURE__*/React.createElement(AddLocationIcon, {
              color: "primary"
            }), /*#__PURE__*/React.createElement(Typography, {
              variant: "caption"
            }, "Check in"))) : null)
          };
        } // ESTADO CHECK_IN FINALIZADO
        else if (data.status === "checking_in" && data.checkin_pending === 0) {
            content = {
              className: moment().isSame(data.date, "day") ? classes.outlinedflexRowNoWrapMH50 : classes.containedflexRowNoWrapMH50,
              content: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
                className: classes.textFlexWidth
              }, /*#__PURE__*/React.createElement(Typography, {
                variant: "body1",
                className: classes.textAnimation5s
              }, data.group.name)), /*#__PURE__*/React.createElement("div", {
                className: classes.containerIcons
              }, /*#__PURE__*/React.createElement("div", {
                className: classes.iconHorizontal
              }, /*#__PURE__*/React.createElement(DoneAllIcon, {
                color: "primary"
              }), /*#__PURE__*/React.createElement(Typography, {
                variant: "caption",
                className: classes.ml8
              }, data.attended || 0)), /*#__PURE__*/React.createElement("div", {
                className: classes.iconHorizontal
              }, /*#__PURE__*/React.createElement(DoneAllIcon, {
                color: "secondary"
              }), /*#__PURE__*/React.createElement(Typography, {
                variant: "caption",
                className: classes.ml8
              }, data.not_attended || 0))), moment().isSame(data.date, "day") ? /*#__PURE__*/React.createElement("div", {
                className: classes.containerIcons
              }, /*#__PURE__*/React.createElement("div", {
                className: classes.iconVertical,
                onClick: function onClick() {
                  return data.handleCheckOutClick(data._id, data.group.name);
                }
              }, /*#__PURE__*/React.createElement(LocationOffIcon, {
                color: "secondary"
              }), /*#__PURE__*/React.createElement(Typography, {
                variant: "caption"
              }, "Check out"))) : null)
            };
          } // ESTADO CHECK_OUT EN PROCESO
          else if (data.status === "checking_out") {
              content = {
                className: moment().isSame(data.date, "day") ? classes.outlinedflexRowNoWrapMH50 : classes.containedflexRowNoWrapMH50,
                content: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
                  className: classes.textFlexWidth
                }, /*#__PURE__*/React.createElement(Typography, {
                  variant: "body1",
                  className: classes.textAnimation5s
                }, data.group.name)), /*#__PURE__*/React.createElement("div", {
                  className: classes.containerIcons
                }, /*#__PURE__*/React.createElement("div", {
                  className: classes.iconHorizontal
                }, /*#__PURE__*/React.createElement(DoneAllIcon, {
                  color: "primary"
                }), /*#__PURE__*/React.createElement(Typography, {
                  variant: "caption",
                  className: classes.ml8
                }, data.attended || 0)), /*#__PURE__*/React.createElement("div", {
                  className: classes.iconHorizontal
                }, /*#__PURE__*/React.createElement(DoneAllIcon, {
                  color: "secondary"
                }), /*#__PURE__*/React.createElement(Typography, {
                  variant: "caption",
                  className: classes.ml8
                }, data.not_attended || 0))), moment().isSame(data.date, "day") ? /*#__PURE__*/React.createElement("div", {
                  className: classes.containerIcons
                }, /*#__PURE__*/React.createElement("div", {
                  className: classes.iconVertical,
                  onClick: function onClick() {
                    return data.handleCheckOutClick(data._id, data.group.name);
                  }
                }, /*#__PURE__*/React.createElement(LocationOffIcon, {
                  color: "secondary"
                }), /*#__PURE__*/React.createElement(Typography, {
                  variant: "caption"
                }, "Check out"))) : null)
              };
            } // ESTADO FINALIZADO
            else if (data.status === "finished") {
                content = {
                  className: classes.containedflexRowNoWrapMH50,
                  content: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
                    className: classes.textFlexWidth
                  }, /*#__PURE__*/React.createElement(Typography, {
                    variant: "body1",
                    className: classes.textAnimation5s
                  }, data.group.name)), /*#__PURE__*/React.createElement("div", {
                    className: classes.containerIcons
                  }, /*#__PURE__*/React.createElement("div", {
                    className: classes.iconHorizontal
                  }, /*#__PURE__*/React.createElement(DoneAllIcon, {
                    color: "primary"
                  }), /*#__PURE__*/React.createElement(Typography, {
                    variant: "caption",
                    className: classes.ml8
                  }, data.attended || 0)), /*#__PURE__*/React.createElement("div", {
                    className: classes.iconHorizontal
                  }, /*#__PURE__*/React.createElement(DoneAllIcon, {
                    color: "secondary"
                  }), /*#__PURE__*/React.createElement(Typography, {
                    variant: "caption",
                    className: classes.ml8
                  }, data.not_attended || 0))))
                };
              } // ESTADO ERRONEO
              else {
                  content = {
                    className: null,
                    content: /*#__PURE__*/React.createElement(Typography, {
                      variant: "body1",
                      color: "error"
                    }, "ERROR STATE ", data.status)
                  };
                }

      break;

    case "calendarActivityStaff":
      content = {
        className: classes.containedFlexColumn,
        content: /*#__PURE__*/React.createElement(React.Fragment, null, data.hours.map(function (hour) {
          return /*#__PURE__*/React.createElement("div", {
            style: {
              display: "flex",
              flexDirection: "row"
            }
          }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Typography, {
            variant: "caption"
          }, hour.hour)), /*#__PURE__*/React.createElement("div", {
            className: [classes.pr16, classes.pl8, classes.w100].join(" ")
          }, hour.groups.map(function (group) {
            return /*#__PURE__*/React.createElement("div", {
              className: classes.containerFlexNoWrap
            }, /*#__PURE__*/React.createElement("div", {
              className: [classes.textFlexWidth, classes.pr8].join(" ")
            }, /*#__PURE__*/React.createElement(Typography, {
              variant: "caption",
              className: classes.textAnimation7s
            }, group.activity.name)), /*#__PURE__*/React.createElement("div", {
              className: classes.iconHorizontalWithoutMargin
            }, /*#__PURE__*/React.createElement(LinkAnimation, {
              to: "".concat(location.pathname, "/groups/").concat(group.group._id, "/activities/").concat(group.activity._id),
              direction: "left",
              state: {
                activityName: group.activity.name,
                groupName: group.group.name,
                tabSelected: "activities"
              }
            }, /*#__PURE__*/React.createElement(RemoveRedEye, {
              fontSize: "small"
            }))));
          })));
        }))
      };
      break;

    case "calendarActivityParent":
      content = {
        className: classes.containedFlexColumn,
        content: /*#__PURE__*/React.createElement(React.Fragment, null, data.hours.map(function (hour) {
          return /*#__PURE__*/React.createElement("div", {
            style: {
              display: "flex",
              flexDirection: "row"
            }
          }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Typography, {
            variant: "caption"
          }, hour.hour)), /*#__PURE__*/React.createElement("div", {
            className: [classes.pr16, classes.pl8, classes.w100].join(" ")
          }, hour.groups.map(function (group) {
            return /*#__PURE__*/React.createElement("div", {
              className: classes.containerFlexNoWrap
            }, /*#__PURE__*/React.createElement("div", {
              className: [classes.textFlexWidth, classes.pr8].join(" ")
            }, /*#__PURE__*/React.createElement(Typography, {
              variant: "caption",
              className: classes.textAnimation7s
            }, group.activity.name)), /*#__PURE__*/React.createElement(LinkAnimation, {
              to: "".concat(location.pathname, "/groups/").concat(group.group._id, "/activities/").concat(group.activity._id),
              direction: "left",
              state: {
                activityName: group.activity.name,
                groupName: group.group.name,
                tabSelected: "activities"
              }
            }, /*#__PURE__*/React.createElement(RemoveRedEye, {
              fontSize: "small"
            })));
          })));
        }))
      };
      break;

    case "calendarAttendanceListParent":
      if (data.status === "draft") {
        content = {
          className: classes.containedflexRowNoWrapMH50,
          content: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
            className: classes.textFlexWidthDFlexColumn
          }, /*#__PURE__*/React.createElement(Typography, {
            variant: "caption"
          }, data.group.name)), /*#__PURE__*/React.createElement(Button, {
            variant: "outlined",
            color: data.child ? data.child.status ? data.child.status === "yes" ? "primary" : data.child.status === "no" ? "secondary" : "inherit" : "inherit" : "inherit",
            className: data.child ? data.child.status ? data.child.status === "maybe" ? [classes.borderYellow, classes.colorYellow].join(" ") : null : null : null
          }, data.child ? data.child.status ? translation ? translation.status ? translation.status[data.child.status] : selects.attendance_status[data.child.status] : selects.attendance_status[data.child.status] : "" : ""))
        };
      } else if (data.status === "checking_in") {
        content = {
          className: classes.containedflexRowNoWrapMH50,
          content: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
            className: classes.textFlexWidthDFlexColumn
          }, /*#__PURE__*/React.createElement(Typography, {
            variant: "caption"
          }, data.group.name)), /*#__PURE__*/React.createElement("div", {
            className: classes.containerIcons
          }, data.child.status === "attended" ? /*#__PURE__*/React.createElement("div", {
            className: classes.iconVertical
          }, /*#__PURE__*/React.createElement(LocationOnIcon, {
            color: data.child.checkin ? "primary" : "inherit",
            onClick: function onClick() {
              return data.child.checkin ? data.handleClickCheckAttendance(data._id, data.child.key, moment(data.date).format("DD/MM/YYYY")) : null;
            }
          }), /*#__PURE__*/React.createElement(Typography, {
            variant: "caption"
          }, translation ? translation.labels ? translation.labels.checkin || "Check in" : "Check in" : "Check in")) : /*#__PURE__*/React.createElement(Chip, {
            label: translation ? translation.checkInStatus[data.child.status] : selects.checkInStatus[data.child.status] || "...",
            className: [classes.chipGroup, classes.not_attended].join(" ")
          })))
        };
      } // CHECKING OUT
      else if (data.status === "checking_out") {
          content = {
            className: classes.containedflexRowNoWrapMH50,
            content: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
              className: classes.textFlexWidthDFlexColumn
            }, /*#__PURE__*/React.createElement(Typography, {
              variant: "caption"
            }, data.group.name)), /*#__PURE__*/React.createElement("div", {
              className: classes.containerIcons
            }, data.child.status === "attended" ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
              className: classes.iconVertical
            }, /*#__PURE__*/React.createElement(LocationOnIcon, {
              color: data.child.checkin ? "primary" : "inherit",
              onClick: function onClick() {
                return data.child.checkin ? data.handleClickCheckAttendance(data._id, data.child.key, moment(data.date).format("DD/MM/YYYY")) : null;
              }
            }), /*#__PURE__*/React.createElement(Typography, {
              variant: "caption"
            }, translation ? translation.labels ? translation.labels.checkin || "Check in" : "Check in" : "Check in")), /*#__PURE__*/React.createElement("div", {
              className: classes.iconVertical
            }, /*#__PURE__*/React.createElement(LocationOffIcon, {
              color: data.child.checkout ? "primary" : "inherit",
              onClick: function onClick() {
                return data.child.checkout ? data.handleClickCheckAttendance(data._id, data.child.key, moment(data.date).format("DD/MM/YYYY")) : null;
              }
            }), /*#__PURE__*/React.createElement(Typography, {
              variant: "caption"
            }, translation ? translation.labels ? translation.labels.checkout || "Check out" : "Check out" : "Check out"))) : /*#__PURE__*/React.createElement(Chip, {
              label: translation ? translation.checkInStatus[data.child.status] : selects.checkInStatus[data.child.status] || "...",
              className: [classes.chipGroup, classes.not_attended].join(" ")
            })))
          };
        } // DEFAULT FINISHED
        else {
            content = {
              className: classes.containedflexRowNoWrapMH50,
              content: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
                className: classes.textFlexWidthDFlexColumn
              }, /*#__PURE__*/React.createElement(Typography, {
                variant: "caption"
              }, data.group.name)), /*#__PURE__*/React.createElement("div", {
                className: classes.containerIcons
              }, data.child.status === "attended" ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
                className: classes.iconVertical
              }, /*#__PURE__*/React.createElement(LocationOnIcon, {
                color: data.child.checkin ? "primary" : "inherit",
                onClick: function onClick() {
                  return data.child.checkin ? data.handleClickCheckAttendance(data._id, data.child.key, moment(data.date).format("DD/MM/YYYY")) : null;
                }
              }), /*#__PURE__*/React.createElement(Typography, {
                variant: "caption"
              }, translation ? translation.labels ? translation.labels.checkin || "Check in" : "Check in" : "Check in")), /*#__PURE__*/React.createElement("div", {
                className: classes.iconVertical
              }, /*#__PURE__*/React.createElement(LocationOffIcon, {
                color: data.checkout ? "secondary" : "inherit",
                onClick: function onClick() {
                  return data.child.checkout ? data.handleClickCheckAttendance(data._id, data.child.key, moment(data.date).format("DD/MM/YYYY")) : null;
                }
              }), /*#__PURE__*/React.createElement(Typography, {
                variant: "caption"
              }, translation ? translation.labels ? translation.labels.checkout || "Check out" : "Check out" : "Check out"))) : /*#__PURE__*/React.createElement(Chip, {
                label: translation ? translation.checkInStatus[data.child.status] : selects.checkInStatus[data.child.status] || "...",
                className: [classes.chipGroup, classes.not_attended].join(" ")
              })))
            };
          }

      break;

    case "groupListStaff":
      content = {
        className: classes.containedFlexColumn,
        content: /*#__PURE__*/React.createElement("div", {
          className: classes.containerFlexNoWrap
        }, /*#__PURE__*/React.createElement("div", {
          className: [classes.textFlexWidth, classes.pr8].join(" ")
        }, /*#__PURE__*/React.createElement(Typography, {
          variant: "caption",
          className: classes.textAnimation7s
        }, data.name)), /*#__PURE__*/React.createElement("div", {
          className: [classes.iconHorizontalWithoutMargin, classes.pr16].join(" ")
        }, /*#__PURE__*/React.createElement(Typography, {
          variant: "caption",
          className: classes.pr8
        }, data.count), /*#__PURE__*/React.createElement(PeopleIcon, {
          fontSize: "small"
        })), /*#__PURE__*/React.createElement("div", {
          className: classes.iconHorizontalWithoutMargin
        }, /*#__PURE__*/React.createElement(LinkAnimation, {
          to: "/app/groups/".concat(data._id),
          direction: "left",
          state: {
            groupName: data.name
          },
          classes: classes.iconHorizontalWithoutMargin
        }, /*#__PURE__*/React.createElement(RemoveRedEye, {
          fontSize: "small"
        }))))
      };
      break;

    case "groupActivityListStaff":
      content = {
        className: classes.containedFlexColumn,
        content: /*#__PURE__*/React.createElement(React.Fragment, null, data.hours.map(function (hour) {
          return /*#__PURE__*/React.createElement("div", {
            style: {
              display: "flex",
              flexDirection: "row"
            }
          }, /*#__PURE__*/React.createElement("div", {
            className: classes.mt8
          }, /*#__PURE__*/React.createElement(Typography, {
            variant: "caption"
          }, hour.hour)), /*#__PURE__*/React.createElement("div", {
            className: [classes.pr16, classes.pl8, classes.w100].join(" ")
          }, hour.activities.map(function (activity) {
            return /*#__PURE__*/React.createElement("div", {
              className: [classes.containerFlexNoWrap, classes.my8].join(" ")
            }, /*#__PURE__*/React.createElement("div", {
              className: [classes.textFlexWidth, classes.pr8].join(" ")
            }, /*#__PURE__*/React.createElement(Typography, {
              variant: "caption",
              className: classes.textAnimation7s
            }, activity.activity.name)), /*#__PURE__*/React.createElement("div", {
              className: classes.iconHorizontalWithoutMargin
            }, /*#__PURE__*/React.createElement(LinkAnimation, {
              to: "".concat(location.pathname, "/activities/").concat(activity.activity._id),
              direction: "left",
              state: {
                activityName: activity.activity.name,
                groupName: activity.group.name,
                tabSelected: "activities"
              }
            }, /*#__PURE__*/React.createElement(RemoveRedEye, {
              fontSize: "small"
            }))));
          })));
        }))
      };
      break;

    case "groupUserListStaffCoordinator":
      content = {
        className: classes.containedFlexColumn,
        content: /*#__PURE__*/React.createElement("div", {
          className: classes.containerFlexNoWrap
        }, /*#__PURE__*/React.createElement("div", {
          className: [classes.textFlexWidth, classes.pr8].join(" ")
        }, /*#__PURE__*/React.createElement(Typography, {
          variant: "caption",
          className: classes.textAnimation7s
        }, data.name)), data.phone && /*#__PURE__*/React.createElement("div", {
          className: [classes.iconHorizontalWithoutMargin, classes.pr16].join(" ")
        }, /*#__PURE__*/React.createElement("a", {
          href: "tel:".concat(data.phone),
          className: classes.linkTelephone
        }, /*#__PURE__*/React.createElement(PhoneIcon, {
          fontSize: "small",
          color: "primary",
          className: classes.pr8
        }), /*#__PURE__*/React.createElement(Typography, {
          variant: "caption",
          className: classes.pr8
        }, data.phone))), /*#__PURE__*/React.createElement("div", {
          className: classes.iconHorizontalWithoutMargin
        }, /*#__PURE__*/React.createElement(LinkAnimation, {
          to: "".concat(location.pathname, "/users/").concat(data.key),
          direction: "left",
          state: {
            userName: data.name,
            groupName: data.group.name
          }
        }, /*#__PURE__*/React.createElement(RemoveRedEye, {
          fontSize: "small"
        }))))
      };
      break;

    case "groupUserListStaffTrainer":
      content = {
        className: classes.containedFlexColumn,
        content: /*#__PURE__*/React.createElement("div", {
          className: classes.containerFlexNoWrap
        }, /*#__PURE__*/React.createElement("div", {
          className: [classes.textFlexWidth, classes.pr8].join(" ")
        }, /*#__PURE__*/React.createElement(Typography, {
          variant: "caption",
          className: classes.textAnimation7s
        }, data.name)), /*#__PURE__*/React.createElement("div", {
          className: classes.iconHorizontalWithoutMargin
        }, /*#__PURE__*/React.createElement(LinkAnimation, {
          to: "".concat(location.pathname, "/users/").concat(data.key),
          direction: "left",
          state: {
            userName: data.name,
            groupName: data.group.name
          }
        }, /*#__PURE__*/React.createElement(RemoveRedEye, {
          fontSize: "small"
        }))))
      };
      break;

    case "groupAttendanceListStaff":
      content = {
        className: [classes.contained, classes.p8].join(" "),
        content: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
          className: classes.containerFlexNoWrap,
          onClick: function onClick() {
            return data.handleCollapse(data._id);
          }
        }, /*#__PURE__*/React.createElement("div", {
          className: classes.textFlexWidth
        }, /*#__PURE__*/React.createElement(Typography, {
          variant: "body1"
        }, data.date)), /*#__PURE__*/React.createElement("div", {
          className: classes.containerIcons
        }, /*#__PURE__*/React.createElement("div", {
          className: classes.iconHorizontal
        }, /*#__PURE__*/React.createElement(DoneAllIcon, {
          color: "primary"
        }), /*#__PURE__*/React.createElement(Typography, {
          variant: "caption",
          className: classes.ml8
        }, data.attending || 0)), /*#__PURE__*/React.createElement("div", {
          className: classes.iconHorizontal
        }, /*#__PURE__*/React.createElement(DoneAllIcon, {
          color: "secondary"
        }), /*#__PURE__*/React.createElement(Typography, {
          variant: "caption",
          className: classes.ml8
        }, data.not_attending || 0)))), /*#__PURE__*/React.createElement(Collapse, {
          "in": data.open
        }, /*#__PURE__*/React.createElement("div", {
          className: classes.minHeight200Flex
        }, /*#__PURE__*/React.createElement(SwitchStatus, {
          status: data.status,
          action_download: function action_download() {
            if (data.open) {
              data.handleDownloadAttendance(data._id);
            }

            return null;
          },
          success: function success() {
            return /*#__PURE__*/React.createElement(Grid, {
              container: true
            }, /*#__PURE__*/React.createElement(ListUserAttendance, {
              data: data.attendance.users,
              handleClickUser: function handleClickUser(key) {
                return data.handleClickUser(key, data._id);
              }
            }));
          }
        }))))
      };
      break;

    case "activityDateStaff":
      content = {
        className: classes.containedFlexColumn,
        content: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
          className: classes.containerIcons
        }, /*#__PURE__*/React.createElement("div", {
          className: classes.iconHorizontalWithoutMargin
        }, /*#__PURE__*/React.createElement(AccessTimeIcon, {
          fontSize: "small"
        }), " ", /*#__PURE__*/React.createElement("div", {
          className: [classes.textFlexWidth, classes.pl8].join(" ")
        }, /*#__PURE__*/React.createElement(Typography, {
          variant: "caption",
          className: classes.textAnimation7s
        }, data.date)))), /*#__PURE__*/React.createElement("div", {
          className: classes.containerIcons
        }, /*#__PURE__*/React.createElement("div", {
          className: classes.iconHorizontalWithoutMargin
        }, /*#__PURE__*/React.createElement(LocationOnIcon, {
          fontSize: "small"
        }), " ", /*#__PURE__*/React.createElement("div", {
          className: [classes.textFlexWidth, classes.pl8].join(" ")
        }, /*#__PURE__*/React.createElement(Typography, {
          variant: "caption",
          className: classes.textAnimation7s
        }, data.venue)))))
      };
      break;

    case "usersUserListStaffCoordinator":
      content = {
        className: classes.containedFlexColumn,
        content: /*#__PURE__*/React.createElement("div", {
          className: classes.containerFlexNoWrap
        }, /*#__PURE__*/React.createElement("div", {
          className: [classes.textFlexWidth, classes.pr8].join(" ")
        }, /*#__PURE__*/React.createElement(Typography, {
          variant: "caption" // className={classes.textAnimation7s}

        }, data.name)), data.phone && /*#__PURE__*/React.createElement("div", {
          className: [classes.iconHorizontalWithoutMargin, classes.pr16].join(" ")
        }, /*#__PURE__*/React.createElement("a", {
          href: "tel:".concat(data.phone),
          className: classes.linkTelephone
        }, /*#__PURE__*/React.createElement(PhoneIcon, {
          fontSize: "small",
          color: "primary",
          className: classes.pr8
        }), /*#__PURE__*/React.createElement(Typography, {
          variant: "caption",
          className: classes.pr8
        }, data.phone))), /*#__PURE__*/React.createElement("div", {
          className: classes.iconHorizontalWithoutMargin
        }, /*#__PURE__*/React.createElement(LinkAnimation, {
          to: "".concat(location.pathname, "/").concat(data.key),
          direction: "left",
          state: {
            userName: data.name
          }
        }, /*#__PURE__*/React.createElement(RemoveRedEye, {
          fontSize: "small"
        }))))
      };
      break;

    case "usersUserListStaffTrainer":
      content = {
        className: classes.containedFlexColumn,
        content: /*#__PURE__*/React.createElement("div", {
          className: classes.containerFlexNoWrap
        }, /*#__PURE__*/React.createElement("div", {
          className: [classes.textFlexWidth, classes.pr8].join(" ")
        }, /*#__PURE__*/React.createElement(Typography, {
          variant: "caption" // className={classes.textAnimation7s}

        }, data.name)), /*#__PURE__*/React.createElement("div", {
          className: classes.iconHorizontalWithoutMargin
        }, /*#__PURE__*/React.createElement(LinkAnimation, {
          to: "".concat(location.pathname, "/").concat(data.key),
          direction: "left",
          state: {
            userName: data.name
          }
        }, /*#__PURE__*/React.createElement(RemoveRedEye, {
          fontSize: "small"
        }))))
      };
      break;

    case "usersAllergyListStaffCoordinator":
      content = {
        className: classes.containedFlexColumn,
        content: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
          className: classes.containerFlexNoWrap
        }, /*#__PURE__*/React.createElement("div", {
          className: [classes.textFlexWidth, classes.pr8].join(" ")
        }, /*#__PURE__*/React.createElement(Typography, {
          variant: "caption" // className={classes.textAnimation7s}

        }, data.name)), data.phone && /*#__PURE__*/React.createElement("div", {
          className: [classes.iconHorizontalWithoutMargin, classes.pr16].join(" ")
        }, /*#__PURE__*/React.createElement("a", {
          href: "tel:".concat(data.phone),
          className: classes.linkTelephone
        }, /*#__PURE__*/React.createElement(PhoneIcon, {
          fontSize: "small",
          color: "primary",
          className: classes.pr8
        }), /*#__PURE__*/React.createElement(Typography, {
          variant: "caption",
          className: classes.pr8
        }, data.phone))), /*#__PURE__*/React.createElement("div", {
          className: classes.iconHorizontalWithoutMargin
        }, /*#__PURE__*/React.createElement(LinkAnimation, {
          to: "".concat(location.pathname, "/").concat(data.key),
          direction: "left",
          state: {
            userName: data.name,
            tabSelected: "allergies"
          }
        }, /*#__PURE__*/React.createElement(RemoveRedEye, {
          fontSize: "small"
        })))), /*#__PURE__*/React.createElement("div", {
          className: classes.containerAlert
        }, /*#__PURE__*/React.createElement(Typography, {
          variant: "caption"
        }, data.allergies)))
      };
      break;

    case "usersAllergyListStaffTrainer":
      content = {
        className: classes.containedFlexColumn,
        content: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
          className: classes.containerFlexNoWrap
        }, /*#__PURE__*/React.createElement("div", {
          className: [classes.textFlexWidth, classes.pr8].join(" ")
        }, /*#__PURE__*/React.createElement(Typography, {
          variant: "caption" // className={classes.textAnimation7s}

        }, data.name)), /*#__PURE__*/React.createElement("div", {
          className: classes.iconHorizontalWithoutMargin
        }, /*#__PURE__*/React.createElement(LinkAnimation, {
          to: "".concat(location.pathname, "/").concat(data.key),
          direction: "left",
          state: {
            userName: data.name,
            tabSelected: "allergies"
          }
        }, /*#__PURE__*/React.createElement(RemoveRedEye, {
          fontSize: "small"
        })))), /*#__PURE__*/React.createElement("div", {
          className: classes.containerAlert
        }, /*#__PURE__*/React.createElement(Typography, {
          variant: "caption"
        }, data.allergies)))
      };
      break;

    case "userParentsListStaff":
      content = {
        className: classes.containedFlexColumn,
        content: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
          variant: "body2"
        }, "".concat(data.name, " ").concat(data.kindship ? "(".concat(data.kindship, ")") : "")), /*#__PURE__*/React.createElement("div", {
          className: [classes.containerIcons, classes.mt8].join(" ")
        }, /*#__PURE__*/React.createElement("a", {
          href: "tel:".concat(data.phone),
          className: [classes.iconHorizontalWithoutMargin, classes.link].join(" ")
        }, /*#__PURE__*/React.createElement(PhoneIcon, {
          fontSize: "small",
          color: "primary",
          className: classes.mr8
        }), /*#__PURE__*/React.createElement("div", {
          className: [classes.textFlexWidth, classes.pl8].join(" ")
        }, /*#__PURE__*/React.createElement(Typography, {
          variant: "caption",
          className: classes.textAnimation7s
        }, data.phone)))), /*#__PURE__*/React.createElement("div", {
          className: classes.containerIcons
        }, /*#__PURE__*/React.createElement("a", {
          href: "mailto:".concat(data.email),
          className: [classes.iconHorizontalWithoutMargin, classes.link, classes.mt4].join(" ")
        }, /*#__PURE__*/React.createElement(EmailIcon, {
          fontSize: "small",
          className: classes.mr8
        }), /*#__PURE__*/React.createElement("div", {
          className: [classes.textFlexWidth, classes.pl8].join(" ")
        }, /*#__PURE__*/React.createElement(Typography, {
          variant: "caption",
          className: classes.textAnimation7s
        }, data.email)))))
      };
      break;

    case "profileShiftListStaff":
      content = {
        className: classes.containedflexRowNoWrapMH50,
        content: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
          className: classes.containerFlex1ColumnAlignCenter
        }, data.start && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
          className: classes.checkInContainer
        }, /*#__PURE__*/React.createElement(Typography, {
          variant: "button",
          color: "primary",
          style: {
            textAlign: "center"
          }
        }, "Check in"), /*#__PURE__*/React.createElement(Typography, {
          variant: "caption",
          color: "white"
        }, moment(data.start.date).format("DD/MM/YYYY HH:mm"))))), /*#__PURE__*/React.createElement("div", {
          className: classes.containerFlex1ColumnAlignCenter
        }, data.status !== "started" ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
          className: classes.checkInContainer
        }, /*#__PURE__*/React.createElement(Typography, {
          variant: "button",
          color: "secondary",
          style: {
            textAlign: "center"
          }
        }, "Check Out"), /*#__PURE__*/React.createElement(Typography, {
          variant: "caption",
          color: "white"
        }, moment(data.end.date).format("DD/MM/YYYY HH:mm")))) : /*#__PURE__*/React.createElement(LinkAnimation, {
          to: "/app/shift/".concat(data._id),
          action: "checkout",
          direction: "left"
        }, /*#__PURE__*/React.createElement(LocationOffIcon, {
          fontSize: "large",
          color: "secondary"
        }))))
      };
      break;

    case "profileServiceListStaff":
      content = {
        className: classes.containedFlexColumn,
        content: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
          className: classes.textFlexWidth
        }, /*#__PURE__*/React.createElement(Typography, {
          variant: "body1",
          className: classes.textAnimation7s
        }, data.name)))
      };
      break;

    case "generalAnnouncementsStaff":
      content = {
        className: classes.outlinedFlexColumn,
        content: /*#__PURE__*/React.createElement("div", {
          className: classes.nameContainer
        }, /*#__PURE__*/React.createElement(LinkAnimation, {
          to: "/app/channels/group/".concat(data.name),
          direction: "left",
          title: translation ? translation.campus : "Camp Announcements",
          classes: classes.fullCardLink
        }, /*#__PURE__*/React.createElement("div", {
          className: [classes.textFlexWidth, classes.pr8].join(" ")
        }, /*#__PURE__*/React.createElement(Typography, {
          variant: "caption",
          className: classes.name
        }, translation ? translation.campus : "Camp Announcements")), /*#__PURE__*/React.createElement("div", {
          className: classes.iconHorizontalWithoutMargin
        }, /*#__PURE__*/React.createElement(KeyboardArrowRightIcon, {
          fontSize: "large"
        }))))
      };
      break;

    case "channelListStaff":
      content = {
        className: classes.outlinedFlexColumn,
        content: /*#__PURE__*/React.createElement("div", {
          className: classes.containerFlexNoWrap
        }, /*#__PURE__*/React.createElement(LinkAnimation, {
          to: "/app/channels/group/".concat(data.rocket_channel.name),
          direction: "left",
          title: data.name,
          classes: classes.fullCardLink
        }, /*#__PURE__*/React.createElement("div", {
          className: [classes.textFlexWidth, classes.pr8].join(" ")
        }, /*#__PURE__*/React.createElement(Typography, {
          variant: "caption",
          className: classes.textAnimation7s
        }, data.name)), /*#__PURE__*/React.createElement("div", {
          className: classes.iconHorizontalWithoutMargin
        }, /*#__PURE__*/React.createElement(KeyboardArrowRightIcon, {
          fontSize: "large"
        }))))
      };
      break;

    case "directMessageListStaffCoordinator":
      content = {
        className: classes.outlinedFlexColumn,
        content: /*#__PURE__*/React.createElement("div", {
          className: classes.containerFlexNoWrap
        }, /*#__PURE__*/React.createElement(LinkAnimation, {
          to: "/app/channels/direct/".concat(data.username),
          direction: "left",
          title: data.name,
          classes: classes.fullCardLink
        }, /*#__PURE__*/React.createElement("div", {
          className: classes.dflex
        }, data.unread ? /*#__PURE__*/React.createElement(Badge, {
          color: "primary" // style={{ color: "#77ffb5" }}
          // badgeContent={" "}
          ,
          variant: "dot",
          anchorOrigin: {
            vertical: "top",
            horizontal: "right"
          }
        }, /*#__PURE__*/React.createElement(ChatIcon, {
          className: classes.chatIcon
        })) : /*#__PURE__*/React.createElement(ChatIcon, {
          className: classes.chatIcon
        }), /*#__PURE__*/React.createElement(Typography, {
          variant: "caption",
          className: classes.ml16
        }, data.name.length > 35 ? "".concat(data.name.substring(0, 30), "...") : data.name)), /*#__PURE__*/React.createElement("div", {
          className: classes.iconHorizontalWithoutMargin
        }, /*#__PURE__*/React.createElement(KeyboardArrowRightIcon, {
          fontSize: "large"
        }))))
      };
      break;

    case "directMessageList":
      content = {
        className: classes.outlinedFlexColumn,
        content: /*#__PURE__*/React.createElement("div", {
          className: classes.containerFlexNoWrap
        }, /*#__PURE__*/React.createElement(LinkAnimation, {
          to: "/app/channels/direct/".concat(data.rocket_chat.username),
          direction: "left",
          title: data.name,
          classes: classes.fullCardLink
        }, /*#__PURE__*/React.createElement("div", {
          className: classes.dflex
        }, data.unread ? /*#__PURE__*/React.createElement(Badge, {
          color: "primary",
          variant: "dot",
          anchorOrigin: {
            vertical: "top",
            horizontal: "right"
          }
        }, /*#__PURE__*/React.createElement(ChatIcon, {
          className: classes.chatIcon
        })) : /*#__PURE__*/React.createElement(ChatIcon, {
          className: classes.chatIcon
        }), /*#__PURE__*/React.createElement(Typography, {
          variant: "caption",
          className: classes.ml16
        }, data.name.length > 35 ? "".concat(data.name.substring(0, 30), "...") : data.name)), /*#__PURE__*/React.createElement("div", {
          className: classes.iconHorizontalWithoutMargin
        }, /*#__PURE__*/React.createElement(KeyboardArrowRightIcon, {
          fontSize: "large"
        }))))
      };
      break;

    case "profileChildrenListParent":
      content = {
        className: classes.containedFlexColumn,
        content: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
          className: classes.containerFlexNoWrap
        }, /*#__PURE__*/React.createElement("div", {
          className: classes.textFlexWidth
        }, /*#__PURE__*/React.createElement(Typography, {
          variant: "body1",
          className: classes.textAnimation7s
        }, data.name)), /*#__PURE__*/React.createElement(CreateIcon, {
          onClick: function onClick() {
            data.handleEditUser(data.childKey, data.serviceId);
          }
        })), /*#__PURE__*/React.createElement(Typography, {
          variant: "body2",
          color: "primary",
          className: classes.mt12b8
        }, translation ? translation.titles ? translation.titles.information || "Information" : "Information" : "Information"), /*#__PURE__*/React.createElement("div", {
          className: [classes.my12, classes.containerFlexWrap, classes.alignItemsCenter].join(" ")
        }, /*#__PURE__*/React.createElement(Typography, {
          variant: "body2",
          className: classes.boldText
        }, translation ? translation.labels ? translation.labels.allergies || "Allergies" : "Allergies" : "Allergies"), /*#__PURE__*/React.createElement(Typography, {
          variant: "caption",
          className: classes.pl8
        }, data ? data.allergies || "" : "")), /*#__PURE__*/React.createElement("div", {
          className: [classes.my12, classes.containerFlexWrap, classes.alignItemsCenter].join(" ")
        }, /*#__PURE__*/React.createElement(Typography, {
          variant: "body2",
          className: classes.boldText
        }, translation ? translation.labels ? translation.labels.comments || "Comments" : "Comments" : "Comments"), /*#__PURE__*/React.createElement(Typography, {
          variant: "caption",
          className: classes.pl8
        }, data ? data.comments || "" : "")), /*#__PURE__*/React.createElement("div", {
          className: [classes.my12, classes.containerFlexWrap, classes.alignItemsCenter].join(" ")
        }, /*#__PURE__*/React.createElement(Typography, {
          variant: "body2",
          className: classes.boldText
        }, translation ? translation.labels ? translation.labels.status || "Status" : "Status" : "Status"), /*#__PURE__*/React.createElement(Typography, {
          variant: "caption",
          className: classes.pl8
        }, data ? data.status ? translation ? translation.status ? translation.status[data.status] : selects.attendance_status[data.status] : selects.attendance_status[data.status] : "" : "")), /*#__PURE__*/React.createElement(Typography, {
          variant: "body2",
          color: "primary",
          className: classes.mt12b8
        }, translation ? translation.titles ? translation.titles.groups || "Groups" : "Groups" : "Groups"), /*#__PURE__*/React.createElement("div", null, data.groups.map(function (group) {
          return /*#__PURE__*/React.createElement(Chip, {
            label: group.name,
            className: classes.chipGroup
          });
        })), /*#__PURE__*/React.createElement("div", {
          className: [classes.containerFlexNoWrap, classes.mt12b8].join(" ")
        }, /*#__PURE__*/React.createElement(Typography, {
          variant: "body2",
          color: "primary"
        }, translation ? translation.titles ? translation.titles.extra_responsibles || "Extra responsibles" : "Extra responsibles" : "Extra responsibles"), /*#__PURE__*/React.createElement(AddCircleIcon, {
          color: "primary",
          onClick: function onClick() {
            data.handleAddResponsible(data.childKey, data.serviceId);
          }
        })), data.extraResponsibles.map(function (extraResponsible) {
          return /*#__PURE__*/React.createElement("div", {
            className: [extraResponsible.status === "authorized" ? classes.outlinedPrimaryFlexColumn : classes.outlinedSecondaryFlexColumn, classes.my8].join(" ")
          }, /*#__PURE__*/React.createElement("div", {
            className: classes.containerFlexNoWrap
          }, /*#__PURE__*/React.createElement("div", {
            className: classes.textFlexWidth
          }, /*#__PURE__*/React.createElement(Typography, {
            variant: "caption"
          }, extraResponsible.name)), /*#__PURE__*/React.createElement(CreateIcon, {
            onClick: function onClick() {
              data.handleEditResponsible(data.childKey, data.serviceId, extraResponsible._id);
            }
          })), /*#__PURE__*/React.createElement("div", {
            className: [classes.my12, classes.containerFlexWrap, classes.alignItemsCenter].join(" ")
          }, /*#__PURE__*/React.createElement(Typography, {
            variant: "body2",
            className: classes.boldText
          }, translation ? translation.labels ? translation.labels.phone || "Phone: " : "Phone: " : "Phone: "), /*#__PURE__*/React.createElement(Typography, {
            variant: "caption",
            className: classes.pl8
          }, extraResponsible.phone || "")), /*#__PURE__*/React.createElement("div", {
            className: [classes.my12, classes.containerFlexWrap, classes.alignItemsCenter].join(" ")
          }, /*#__PURE__*/React.createElement(Typography, {
            variant: "body2",
            className: classes.boldText
          }, translation ? translation.labels ? translation.labels.responsible_status || "Status: " : "Status: " : "Status: "), /*#__PURE__*/React.createElement(Typography, {
            variant: "caption",
            className: classes.pl8
          }, extraResponsible.status === "authorized" ? translation ? translation.labels ? translation.labels.authorized || "Authorized" : "Authorized" : "Authorized" : extraResponsible.status === "not_authorized" ? translation ? translation.labels ? translation.labels.not_authorized || "Not authorized" : "Not authorized" : "Not authorized" : extraResponsible.status)));
        }))
      };
      break;

    case "satisfactionListParent":
      content = {
        className: classes.containedFlexColumn,
        content: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
          className: classes.textFlexWidth
        }, /*#__PURE__*/React.createElement(Typography, {
          variant: "body1"
        }, data.name)), /*#__PURE__*/React.createElement("div", {
          style: {
            display: "flex",
            justifyContent: "flex-end",
            flex: "1"
          }
        }, /*#__PURE__*/React.createElement(LinkAnimation, {
          to: data.rated ? "".concat(location.pathname, "/").concat(data.satisfactionId) : "".concat(location.pathname, "/").concat(data._id, "/rate"),
          state: {
            owner: data.franchise
          },
          direction: "left"
        }, /*#__PURE__*/React.createElement(Button, {
          variant: data.rated ? "contained" : "outlined",
          color: "primary"
        }, data.rated ? translation ? translation.buttons ? translation.buttons.rated || "Rated" : "Rated" : "Rated" : translation ? translation.buttons ? translation.buttons.rate || "Rate" : "Rate" : "Rate"))))
      };
      break;

    default:
      break;
  }

  return content;
};

var MobileCardItem = function MobileCardItem(props) {
  // console.log("MobileCardItem props", props);
  var location = useLocation();
  var classes = useStyles();
  var template = props.template ? templates(props.template, classes, props.data, location, props.translation) || null : null; // console.log("template", template, props.template, props.data);

  return /*#__PURE__*/React.createElement("div", {
    className: [template ? template.className : props.variant ? classes[props.variant] : classes.contained, props.classes || null].join(" ")
  }, template ? template.content : props.children);
};

export { MobileCardItem };